import React, {Component} from 'react';
import { SelectList } from '../FormUI';
import countries from '../../datasets/country_region_city.json';

export class RegionController{

    country = {};
    district = {};
    city = {};

    handleCountryChange = (val)=>{
        if(this.district){
            this.district.setDistricts((val || {}).districts);
        }        
    }

    handleDistrictChange = (val) => {
        if(this.city){
            this.city.setCities((val || {}).value);
        }        
    }
}

/*export default class RegionSelectList extends Component{
    state = {};
    get controller(){
        return this.props.controller || {};
    }
    handleCountryChange = (val)=>{
        console.log("Country Change:", val);
        this.setState({country:val, districts:val.districts});
        
    }

    handleDistrictChange = (val) => {
        console.log("District:", val)
        this.setState({cities:val.value});
    }

    render(){
        return(
            <div>
                <CountrySelectList value={this.state.country} onChange={this.handleCountryChange}/>
                <DistrictSelectList districts={this.state.districts} onChange={this.handleDistrictChange} />
                <CitySelectList cities={this.state.cities}/>
            </div>  
        )
    }
}*/

export class CountrySelectList extends Component{

    constructor(props){
        super(props);
        if(this.props.controller){
            this.props.controller.country = this;
        }
    }

    get controller(){
        return this.props.controller || {};
    }

    render(){
        let {options, valueKey, labelKey, ...props} = this.props;
        return(
            <SelectList onChange={this.controller.handleCountryChange} valueKey='districts' labelKey='name' options={countries} {...props} />
        )
    }
}

export class DistrictSelectList extends Component{
    state = {};
    constructor(props){
        super(props);
        if(this.props.controller){
            this.props.controller.district = this;
        }
    }

    get controller(){
        return this.props.controller || {};
    }


    setDistricts(d){
        this.setState({districts:d});
    }

    genList(){
        let list = [];
        let districts = this.state.districts;
        if(districts){
            for(let p in districts){
                let cities = districts[p];
                list.push({label:p, value:cities});
            }
        }

        return list;
    }

    render(){
        let {options, districts, ...props} = this.props;
        return(
            <SelectList options={this.genList()} onChange={this.controller.handleDistrictChange} {...props} />
        )
    }
}

export class CitySelectList extends Component{
    state = {};
    constructor(props){
        super(props);
        if(this.props.controller){
            this.props.controller.city = this;
        }
    }

    setCities = (c)=>{
        this.setState({cities:c});
    }

    getList(){
        let list = [];
        let cities = this.state.cities;
        if(cities){
            for(let i=0 ; i < cities.length; i++){
                let city = cities[i];
                list.push({label:city, value:city});
            }
        }
        return list;
    }

    render(){
        let {options, districts, ...props} = this.props;
        return(
            <SelectList options={this.getList()}  {...props} />
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/datalists/RegionSelectLists.js